var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedium({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C7.02991 3 3 7.02991 3 12C3 16.9701 7.02991 21 12 21C16.9701 21 21 16.9701 21 12C21 7.02991 16.9701 3 12 3ZM17.1429 8.09665L16.3232 8.88214C16.2509 8.93638 16.2167 9.02478 16.2308 9.11116V14.8908C16.2167 14.9792 16.2509 15.0676 16.3232 15.1199L17.1268 15.9054V16.0801H13.0929V15.9134L13.9225 15.1078C14.0049 15.0254 14.0049 15.0013 14.0049 14.8788V10.202L11.6946 16.06H11.3833L8.69531 10.202V14.1295C8.67121 14.2942 8.72946 14.4609 8.84598 14.5795L9.92679 15.8873V16.0621H6.85714V15.8873L7.93795 14.5795C8.05446 14.4609 8.10469 14.2922 8.07857 14.1295V9.58929C8.09263 9.46272 8.04442 9.34018 7.94799 9.25379L6.98772 8.09665V7.92188H9.97098L12.2732 12.9743L14.3002 7.92589H17.1429V8.09665Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.2616453089c636697607ba416d0ffb5e.svg";
export { ForwardRef as ReactComponent };